import VideoForm from "./VideoForm";
import PostForm from "./PostForm";
import PostMessageForm from "./PostMessageForm";

export default {
    videoForm: new VideoForm(),
    postForm: new PostForm(),
    postMessageForm: new PostMessageForm()
};




// WEBPACK FOOTER //
// ./src/forms/_.forms.js